import header from './header'
import nav from './nav'
import bgimg from './bgimg'
import footer from './footer'
import layout from './layout'
import member from './member'
import sidebar from './sidebar'
export default {header, nav, bgimg, footer, layout, member, sidebar}



// WEBPACK FOOTER //
// ./src/components/index.js